var contactPage = {
    CONTACTUS : "0",
    FRANCHISE : "1",
    CAREER : "2",
    LISTAPROPERTY : "3",
    MEDIA : "4"
};

var contactForms = (function() {
   var oLoadingIndicator = null;
   var m_internationalization = window.internationalization;

   /**
    * Get the parameters from the email form and add them to params
    *
    * @private
    * @param params
    *            the object to add items to
    */
   function processEmailForm(params) {
      params.firstname = $("#firstName").val();
      params.lastname = $("#lastName").val();
      params.email = $("#email").val();
      params.phone = $("#phone").val();
      params.comments = $("#comments").val();
      params.yesiwould = $("#c21emails").prop('checked') ? 'on' : '';
      params.formcontacttype = $("#formContactType").val();

      var contactType = $('input:radio[name=RadioGroup1]:checked');
      if (contactType) {
          params.contacttype = contactType.val();
      }
   }

   /**
    * Get the parameters from the email popup form and add them to params
    *
    * @private
    * @param params
    *            the object to add items to
    */
   function processEmailPopupForm(params) {
      params.firstname = $("#popupFirstName").val();
      params.lastname = $("#popupLastName").val();
      params.email = $("#popupEmail").val();
      params.phone = $("#popupPhone").val();
      params.comments = $("#popupComments").val();
      params.yesiwould = $("#popupC21emails").prop('checked') ? 'on' : '';
      params.contacttype = $('input:radio[name=RadioGroupModal]:checked').val();

      // UTM Fields
      params.utm_source = $("#popup_utm_source").val();
      params.utm_medium = $("#popup_utm_medium").val();
      params.utm_campaign = $("#popup_utm_campaign").val();
      params.utm_content = $("#popup_utm_content").val();
      params.utm_term = $("#popup_utm_term").val();
      params.utm_lead_id = $("#popup_utm_lead_id").val();
      params.utm_lead_source = $("#popup_utm_lead_source").val();
   }

   /**
    * Set the hidden UTM form fields from storage.
    */
   function setUtmFields() {
      if (window.getC21GtmUtmParameters) {
         let utmParams = window.getC21GtmUtmParameters();
         if (!utmParams) {
            return;
         }

         const fields = [
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_content',
            'utm_term',
            'utm_lead_id',
            'utm_lead_source'
         ];

         fields.forEach(field => {
            if (utmParams[field]) {
               $(`#${field}`).val(utmParams[field]);
               $(`#popup_${field}`).val(utmParams[field]);
            }
         });
      } else {
         setTimeout(setUtmFields, 100);
      }
   }

   /**
    * Validate comments.
    * Returns false if the length > 1000. Otherwise, returns true.
    *
    * @returns boolean
    */
   function validateComments(comments) {
      var valid = true;
      if(comments && comments.length > 1000) {
    	 valid = false;
    	 var jComments = $("#comments");
    	 if($("#popupComments").length > 0) {
    	    jComments = $("#popupComments");
    	 }
    	 var errorMessage = m_internationalization.getString("Limit to 1000 characters") + ".";
    	 var errorSpan = jComments.parent().find(".fieldError");
    	 var errorSpanHtml = errorSpan.html();
    	 if(errorSpan.length === 0) {
            $("<span class='fieldError'>" + errorMessage + "<br></span>").insertBefore(jComments);
    	 } else if(errorSpanHtml.indexOf('1000') <= 0) {
            errorSpan.html(errorMessage);
    	 } else {
            errorSpan.show();
    	 }
      }
	  return valid;
   }

   function doSubmit(strSubView, strUrl, params, sLoading, options, strForm) {
      var jForm = $(strForm);
      var aErrors = formValidator.updateErrors(jForm);

      if(aErrors.length !== 0) {
         return;
      }

      // Scroll to top 
      var bScrollTop = true;
      if(options && options.scrollTop === false) {
         bScrollTop = false;
      }
      if(bScrollTop) {
         portalAjax.scrollToTop();
      }
      
      if (sLoading && window.LoadingIndicator) {
         var jLoading = $(sLoading);
         oLoadingIndicator = new LoadingIndicator(jLoading);
         portalAjax.bindLoadEvent(jLoading, onSubmitLoad);
      }
      portalAjax.doViewEngineAjax(strSubView, strUrl, $.param(params), options);
   }

   function onSubmitLoad() {
      oLoadingIndicator.destroy();
      ImageLazyLoader.loadImages();
   }

   function toggleContactTypeRegular(){
	  toggleContactTypeRegularRec("contacttype", "emailrequired", "phonerequired");
   }

   function toggleContactType(){
      toggleContactTypeRec("contacttype", "emailrequired", "phonerequired");
   }

   function toggleEspContentContactType(name, emailrequired, phonerequired) {
      var contactType = $('input:radio[name='+name+']:checked').val();
      if(contactType == 'email'){
         $("#" + emailrequired).text("*");
         $("#EMAILERROR").hide();;
         $("#PHONEERROR").hide();
      }else if(contactType == 'phone'){
         $("#" + emailrequired).text(" ");
         $("#EMAILERROR").hide();
         $("#PHONEERROR").hide();
      }else{
         $("#" + emailrequired).text("*");
         $("#EMAILERROR").hide();
         $("#PHONEERROR").hide();
      }
   }

   function toggleContactTypeRec(name, emailrequired, phonerequired){
     var contactType = $('input:radio[name='+name+']:checked').val();
     if(contactType == 'email'){
        $("#" + emailrequired).text("*");
        $("#EMAILERROR").text("");
        $("#PHONEERROR").text("");
     }else if(contactType == 'phone'){
        $("#" + emailrequired).text(" ");
        $("#EMAILERROR").text("");
        $("#PHONEERROR").text("");
     }else{
        $("#" + emailrequired).text("*");
        $("#EMAILERROR").text("");
        $("#PHONEERROR").text("");
     }
   }

   function toggleContactTypeRegularRec(name, emailrequired, phonerequired) {
      var contactType = $('input:radio[name='+name+']:checked').val();
      if(contactType == 'email') {
         $("#" + emailrequired).text("*");
         $("#" + phonerequired).text(" ");
      } else if(contactType == 'phone') {
         $("#" + phonerequired).text("*");
         $("#" + emailrequired).text(" ");
      } else {
         $("#" + emailrequired).text("*");
         $("#" + phonerequired).text("*");
      }
      $("#EMAILERROR").text("");
      $("#PHONEERROR").text("");
   }

   var sendToFriendForm = PortalForm("#sendtofriendWindow", "sendToFriend", "/sendToFriend.c21");
   sendToFriendForm.open = function(propertyKey) {
      sendToFriendForm.load({propertyKey : propertyKey});
      trackListing(propertyKey, "Email");
   }

   function trackListing(key, type) {
      if (key.indexOf("CBR") < 0 && key.indexOf("ERA") < 0
            && key.indexOf("LCE") < 0) {
         key = key.replace("C21", "");
         portalAjax.report({
            url : "/reporting/listing",
            data : "id=" + key + "&type=" + type
         });
      }
   }

   function trackAgent(key, type) {
      portalAjax.report({
         url : "/reporting/agent",
         data : "id=" + key + "&type=" + type
      });
   }

   function trackOffice(key, type) {
      portalAjax.report({
         url : "/reporting/office",
         data : "id=" + key + "&type=" + type
      });
   }

   return {
      sendToFriendForm : sendToFriendForm,
      toggleContactType : toggleContactType,
      toggleContactTypeRegular: toggleContactTypeRegular,
      toggleContactTypeRegularRec: toggleContactTypeRegularRec,
      toggleContactTypeRec : toggleContactTypeRec,
      toggleEspContentContactType: toggleEspContentContactType,
      setUtmFields : setUtmFields,

      submitContactAgent : function() {
         Track.doTracking('adp-inline-submit');

         // Get the source contact id
         var sourceContactID = $("#id").val();
         if(sourceContactID == 'Agent' || sourceContactID == 'Team') {
            sourceContactID = $("#sourceContactID").val();
         }

         var params = {
            id : sourceContactID,
            source : 'Agent Details Page'
         };

         processEmailForm(params);
         doSubmit('contact.emailAgent', '/contactAgent.c21', params, '#contactCard', {scrollTop: false}, '#contactCard');
         return false;
      },

      submitContactOfficePopup : function(officeKey, sourcePage) {
         Track.doTracking('srm-office-submit');
         var params = {
            id : officeKey,
            source : 'Office Contact Popup',
            sourcePage: sourcePage,
            submitted: 'true'
         };

         processEmailPopupForm(params);
         doSubmit('contact.emailOfficePopup', '/contactOffice.c21', params, '.nonPropertyContactWrapper', null, '.nonPropertyContactWrapper');
         return false;
      },

      submitContactAgentPopup : function(agentKey, sourcePage) {
         Track.doTracking('srm-agent-submit');
         var params = {
            agentKey : agentKey,
            source : 'Agent Contact Popup',
            sourcePage: sourcePage,
            submitted: 'true'
         };

         processEmailPopupForm(params);
         doSubmit('contactPopup', '/contactAgent.c21', params, '.nonPropertyContactWrapper', null, '.nonPropertyContactWrapper');
         return false;
      },

      submitContactPropertyPopup : function(propertyKey, sType, sourcePage, renSourceKey, rndOfficeKey) {
         switch (sType) {
            case 'seeProperty':
               Track.doTracking('pdp-see-property-submit');
               break;
            case 'askQuestion':
               Track.doTracking('pdp-ask-question-submit');
               break;
            default:
               Track.doTracking('srm-property-submit');
               break;
         }
         var params = {
            sourceType : sType,
            sourcePage : sourcePage,
            propertyKey : propertyKey,
            renSourceKey: renSourceKey,
            rndOfficeKey: rndOfficeKey,
            source : 'Property Contact Popup',
            submitted: 'true'
         };

         processEmailPopupForm(params);
         doSubmit('contactPropertyPopup', '/contactProperty.c21', params, '.contactPropertyBox', null, '.contactPropertyBox');
         return false;
      },

      submitContactIDXPropertyPopup : function(propertyKey, sType, sourcePage, feedID, officeKey) {
          switch (sType) {
             case 'seeProperty':
                Track.doTracking('pdp-see-property-submit');
                break;
             case 'askQuestion':
                Track.doTracking('pdp-ask-question-submit');
                break;
             default:
                Track.doTracking('srm-property-submit');
                break;
          }
          var params = {
             sourceType : sType,
             sourcePage : sourcePage,
             obID : propertyKey,
             feed: feedID,
             officeKey: officeKey,
             source : 'Property Contact Popup',
             submitted: 'true'
          };

          processEmailPopupForm(params);
          doSubmit('contactPropertyPopup', '/idxajax/contactIDXProperty.c21', params, '#contactCard', null, '#contactCard');
          return false;
       },

       submitContactHandoff : function() {
         Track.doTracking('en-handoff-inline-submit');
         var params = {
            id : $("#id").val(),
            source : 'EN Handoff Details Page'
         };

         processEmailForm(params);

         params.lidxurl = $("#lidxurl").val();
         params.lmls = $("#lmls").val();
         params.laddress = $("#laddress").val();
         params.lcity = $("#lcity").val();
         params.lstate = $("#lstate").val();
         params.lzip = $("#lzip").val();
         params.ltype = $("#ltype").val();
         params.lid = $("#lid").val();
         params.lmlsid = $("#lmlsid").val();

         doSubmit('contact.emailOffice', '/contactIDX2.c21', params, '#contactCard', null, '#contactCard');
         return false;
      },

      submitContactOffice : function(sourcePage) {
         Track.doTracking('odp-inline-submit');

         // Get the source contact id
         var sourceContactID = $("#id").val();

         //Get the source
         var contactSource = '';
         if( (sourcePage != null) && (sourcePage == 'ADP' || sourcePage == 'TDP')) {
        	 contactSource = 'Agent Details Page';
        	 if(sourceContactID == 'Office') {
                sourceContactID = $("#sourceContactID").val();
        	 }
         } else {
        	 contactSource = 'Office Details Page';
         }

         var params = {
            id : sourceContactID,
            source : contactSource,
            sourcePage: sourcePage
         };

         processEmailForm(params);
         doSubmit('contact.emailOffice', '/contactOffice.c21', params, '#contactCard', {scrollTop: false}, '#contactCard');
         return false;
      },

      submitContactProperty : function(propertyKey, renSourceKey, rndOfficeKey) {
         Track.doTracking('pdp-inline-submit');
         var params = {
            propertyKey : propertyKey,
            renSourceKey: renSourceKey,
            rndOfficeKey: rndOfficeKey,
            source : 'Property Details Page'
         };

         processEmailForm(params);
         doSubmit('contact.emailProperty', '/contactProperty.c21', params, '#contactCard', null, '#contactCard');
         return false;
      },

      submitContactIDXProperty : function(propertyKey, feedID, officeKey) {
          Track.doTracking('pdp-inline-submit');
          var params = {
             obID : propertyKey,
             feed: feedID,
             officeKey: officeKey,
             source : 'Property Details Page'
          };

          processEmailForm(params);
          doSubmit('contact.emailProperty', '/idxajax/contactIDXProperty.c21', params, '#contactCard', null, '#contactCard');
          return false;
       },

       submitContactUs : function() {
         Track.doTracking('contact-us-submit');
          var params = {
             source : 'Contact Us Page',
             p : contactPage.CONTACTUS,
             name : $("#name").val(),
             email : $("#email").val(),
             phone : $("#phone").val(),
             category : $("#category").val(),
             subject : $("#subject").val(),
             comments : $("#comments").val(),
             yesiwould : $("#yesiwould").prop('checked') ? 'yes' : '',
             submit : 'submit'
          };

          var options= {};
          options.requestType = "POST";

          doSubmit('contact.contactus', '/contact.c21', params, '#BodyRightLane', options, '#generalQuestionForm');
          return false;
       },
       
       submitFindAndContactAgent : function(agentID) {
          Track.doTracking('find-contact-agent-submit');
          var params = {
             source : 'Find and Contact Agent Page',
             agentid : agentID,
             firstname : $("#firstName").val(),
             lastname : $("#lastName").val(),
             email : $("#email").val(),
             phone : $("#phone").val(),
             comments : $("#comments").val(),
             yesiwould : $("#yesiwould").prop('checked') ? 'yes' : '',
             contacttype : $('input:radio[name=RadioGroup1]:checked').val(),
             submit : 'submit'
          };

          var options= {};
          options.requestType = "POST";

          doSubmit('FindAnAgentContact', '/findandcontactagent.c21', params, '#findAgentForm', options, '#findAgentForm');
          return false;            
       },

       submitFranchiseContact : function() {
          Track.doTracking('contact-franchise-submit');

          var yesToContact = 'no';
          if($("#yesiwould").attr("checked")) {
        	  yesToContact = 'yes';
          }

          var params = {
             source : 'Contact Franchise Page',
             p : contactPage.FRANCHISE,
             firstname : $("#firstname").val(),
             lastname : $("#lastname").val(),
             city: $("#city").val(),
             state: $("#state").val(),
             companyname : $("#companyname").val(),
             email : $("#email").val(),
             phone : $("#phone").val(),
             timeinbusiness : $("#timeinbusiness").val(),
             currentjob : $("#currentjob").val(),
             brand : $("#brand").val(),
             franchisetime : $("#franchisetime").val(),
             comments : $("#comments").val(),
             yesiwould : yesToContact,
             partoffranchise : $('input:radio[name=partoffranchise]:checked').val(),
             brokerage : $('input:radio[name=brokerage]:checked').val(),
             veteran: $('input:radio[name=veteran]:checked').val(),
             contacttype : $('input:radio[name=contacttype]:checked').val(),
             submit : 'submit'
          };

          doSubmit('contact.franchise', '/contact.c21', params, '#BodyRightLane', null, '#contactFranchiseForm');
          return false;
       },

       /**
        * Submit the content franchise contact form
        */
       submitContentFranchiseContact : function() {
           Track.doTracking('contact-franchise-submit');
           var params = {
              source : 'Contact Franchise Page',
              p : contactPage.FRANCHISE,
              firstname : $("#firstname").val(),
              lastname : $("#lastname").val(),
              city: $("#city").val(),
              state: $("#state").val(),
              companyname : $("#companyname").val(),
              email : $("#email").val(),
              phone : $("#phone").val(),
              timeinbusiness : $("#timeinbusiness").val(),
              currentjob : $("#currentjob").val(),
              brand : $("#brand").val(),
              franchisetime : $("#franchisetime").val(),
              comments : $("#comments").val(),
              yesiwould : $("#yesiwould").prop('checked') ? 'yes' : '',
              partoffranchise : $('input:radio[name=partoffranchise]:checked').val(),
              brokerage : $('input:radio[name=brokerage]:checked').val(),
              veteran: $('input:radio[name=veteran]:checked').val(),
              contacttype : $('input:radio[name=contacttype]:checked').val(),
              submit : 'submit'
           };

           doSubmit('contact.contentfranchise', '/contact.c21', params, '#contentContactFranchiseForm', null, '#contentContactFranchiseForm');
           return false;
        },

        /**
         * Show the content franchise contact form errors
         *
         */
        showContentContactFranchiseErrors: function(data) {
           	//Hide all the current error messages
           	$(".fieldError").hide();

           	//Show only the new error messages sent by the server
           	$.each(data.errors, function (name, error) {
           		if(error.name != null && error.name != "") {
           			var errorspan = "#" + error.name + "ERROR";
           			$(errorspan).show();
           			if(window.websiteCode != 'ESP') {
           			   $(errorspan).text(" " + error.value);
           			}
           		}
            });
        },

       submitCareerContact : function() {
          Track.doTracking('contact-career-submit');
          var params = {
             source : 'Contact Career Page',
             p : contactPage.CAREER,
             firstname : $("#firstname").val(),
             lastname : $("#lastname").val(),
             email : $("#email").val(),
             phone : $("#phone").val(),
             zipcode : $("#zipcode").val(),
             comments : $("#comments").val(),
             yesiwould : $("#yesiwould").prop('checked') ? 'yes' : '',
             havelicense : $('input:radio[name=havelicense]:checked').val(),
             contacttype : $('input:radio[name=contacttype]:checked').val(),
             submit : 'submit'
          };

          doSubmit('contact.career', '/contact.c21', params, '#BodyRightLane', null, '#contactCareerForm');
          return false;
       },

       /**
        * C21.com career contact form (redesign).
        * 
        */
       submitCareerContactForm : function() {
           Track.doTracking('contact-career-submit');
           var params = {
              source : 'Contact Career Page',
              p : contactPage.CAREER,
              firstname : $("#firstname").val(),
              lastname : $("#lastname").val(),
              email : $("#email").val(),
              phone : $("#phone").val(),
              zipcode : $("#zipcode").val(),
              comments : $("#comments").val(),
              yesiwould : $("#yesiwould").prop('checked') ? 'yes' : '',
              havelicense : $('input:radio[name=havelicense]:checked').val(),
              contacttype : $('input:radio[name=contacttype]:checked').val(),
              submit : 'submit'
           };
           
           var options = {};
           options.scrollTop = false;
           
           doSubmit('contact.career', '/contact.c21', params, '#BodyRightLane', options, '#contactCareerForm');
           return false;
       },       
       
       /**
        * Submit the content career contact form
        *
        */
       submitContentCareerContact : function() {
           Track.doTracking('contact-career-submit');
           var params = {
              source : 'Contact Career Page',
              p : contactPage.CAREER,
              firstname : $("#firstname").val(),
              lastname : $("#lastname").val(),
              email : $("#email").val(),
              phone : $("#phone").val(),
              zipcode : $("#zipcode").val(),
              comments : $("#comments").val(),
              yesiwould : $("#yesiwould").prop('checked') ? 'yes' : '',
              havelicense : $('input:radio[name=havelicense]:checked').val(),
              contacttype : $('input:radio[name=contacttype]:checked').val(),
              submit : 'submit'
           };

           doSubmit('contact.contentcareer', '/contact.c21', params, '#contentContactCareerForm', null, '#contentContactCareerForm');
           return false;
       },

       /**
        * Show the content career contact form errors
        *
        */
       showContentContactCareerErrors: function(data) {
       	  //Hide all the current error messages
       	  $(".fieldError").hide();

           //Show only the new error messages sent by the server
           $.each(data.errors, function (name, error) {
             if(error.name != null && error.name != "") {
               var errorspan = "#" + error.name + "ERROR";
               $(errorspan).show();
               if(window.websiteCode != 'ESP') {
                  $(errorspan).text(" " + error.value);
               }
             }
          });
       },

       gaTrackListAPropertyOffice : function(officekey, active) {
    	   if(active) {
    	      Track.doEvent('Contact Us - List a Property', 'Add CENTURY21 Office', officekey);
    	   } else {
     	      Track.doEvent('Contact Us - List a Property', 'Remove CENTURY21 Office', officekey);
    	   }
       },

       submitListAPropertyIntro : function() {
          Track.doTracking('list-property-form');
          var params = {
             source : 'List A Property Page',
             p : contactPage.LISTAPROPERTY,
             zipcode : $("#zipcode").val(),
             submit : 'introsubmit'
          };

          doSubmit('contact.listaproperty', '/contact.c21', params, '#BodyRightLane');
          return false;
       },

       submitListAPropertyContact : function() {
          Track.doTracking('list-property-submit');
          var cb_officekeys = $('input:checkbox[name=officekey]:checked');
          var officekeys = "";
          var sep = "";
          for(var i=0; i<cb_officekeys.length; i++){
             officekeys += sep+cb_officekeys[i].value;
             sep=",";
          }
          var params = {
             source : 'List A Property Page',
             p : contactPage.LISTAPROPERTY,
             firstname : $("#firstname").val(),
             lastname : $("#lastname").val(),
             email : $("#email").val(),
             phone : $("#phone").val(),
             zipcode : $("#zipcode").val(),
             comments : $("#comments").val(),
             yesiwould : $("#yesiwould").val(),
             officekey : officekeys,
             contacttype : $('input:radio[name=contacttype]:checked').val(),
             submit : 'submit'
          };

          doSubmit('contact.listaproperty', '/contact.c21', params, '#BodyRightLane');
          return false;
       },

       /**
        * Submit list a property contact form (redesign)
        *
        */
       submitListAPropertyContactForm : function() {
           Track.doTracking('list-property-submit');
           var params = {
              source : 'List A Property Page',
              firstname : $("#firstname").val(),
              lastname : $("#lastname").val(),
              email : $("#email").val(),
              phone : $("#phone").val(),
              zipcode : $("#zipcode").val(),
              comments : $("#comments").val(),
              yesiwould : $("#ohyesiwould").prop('checked') ? 'yes' : '',
              contacttype : $('input:radio[name=contacttype]:checked').val(),
              submit : 'submit'
           };

           var options= {};
           options.requestType = "POST";

           doSubmit('contact.listaproperty', '/contactlistaproperty.c21', params, '#listAPropertyLayout', options, '#lpContactForm');
           return false;
      },

      submitMediaContact : function() {
         Track.doTracking('contact-media-submit');
         var params = {
            source : 'Contact Media Page',
            p : contactPage.MEDIA,
            firstname : $("#firstname").val(),
            lastname : $("#lastname").val(),
            title : $("#title").val(),
            affiliation : $("#affiliation").val(),
            email : $("#email").val(),
            phone : $("#phone").val(),
            comments : $("#comments").val(),
            contacttype : $('input:radio[name=contacttype]:checked').val(),
            yesiwould: $("#yesiwould").prop('checked') ? 'yes' : '',
            submit : 'submit'
         };

         doSubmit('contact.media', '/contact.c21', params, '#BodyRightLane', null, '#generalQuestionForm');
         return false;
      },

      setLeadFormDirty : function() {
         $("#leadFormChanged").val("true");
      },

      clearLeadFormDirty : function() {
         $("#leadFormChanged").val("false");
      },

      isLeadFormDirty : function() {
         if($("#leadFormChanged").val() == "true") {
            return true;
         }
         return false;
      },

      /**
       * GA Tracking of Modal Lead Contact Form - Agent/Office/Property
       *
       */
      gaTrackLeadModalContactForm : function(sourcePage) {
          var trackData = "";
          var hasTrackData = "";
          var firstName = $("#popupFirstName").val();
          var lastName = $("#popupLastName").val();
          var yesiwould = $("#c21emails");

          var contactType = "";
          var contactTypeElement = $('input:radio[name=RadioGroupModal]:checked');
          if (contactTypeElement) {
             contactType = contactTypeElement.val();
          }

          var email = $("#popupEmail").val();
          var phone = $("#popupPhone").val();
          var comments = $("#popupComments").val();

          if(firstName != null && firstName != "") {
             trackData = "First Name";
             hasTrackData = "Y";
          }
          if(lastName != null && lastName != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Last Name";
             hasTrackData = "Y";
          }
          if(contactType != null && contactType != "" && contactType != "email") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Contact Type";
             hasTrackData = "Y";
          }
          if(email != null && email != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Email";
             hasTrackData = "Y";
          }
          if(phone != null && phone != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Phone";
             hasTrackData = "Y";
          }

          //Receive C21 Emails
          if(sourcePage == "Property Contact Modal") {
        	  var yesiwould = $("#popupC21emails");
	          if(yesiwould != null && !yesiwould.attr("checked")) {
	 	         if(hasTrackData) trackData = trackData + ",";
	 	         trackData = trackData + "Receive C21 Emails";
	 	         hasTrackData = "Y";
	          }
	          if(comments != null && comments != "" && $.trim(comments) != $.trim($("#initialPopupComments").val())) {
	             if(hasTrackData) trackData = trackData + ",";
	             trackData = trackData + "Comments";
	             hasTrackData = "Y";
	          }
          } else {
        	  var yesiwould = $("#c21emails");
              if(yesiwould != null && !yesiwould.attr("checked")) {
     	         if(hasTrackData) trackData = trackData + ",";
     	         trackData = trackData + "Receive C21 Emails";
     	         hasTrackData = "Y";
              }
              if(comments != null && comments != "") {
                 if(hasTrackData) trackData = trackData + ",";
                 trackData = trackData + "Comments";
                 hasTrackData = "Y";
              }
          }

          if(hasTrackData && sourcePage != null && sourcePage != "") {
             Track.doEvent(sourcePage, 'Form Abandonment', trackData);
          }
      },

      /**
       * GA Tracking of Inline Lead Contact Form - ADP/ODP/FIND AN AGENT 
       *
       */
      gaTrackLeadInlineContactForm : function(sourcePage) {
          var trackData = "";
          var hasTrackData = "";
          var firstName = $("#firstName").val();
          var lastName = $("#lastName").val();

          var contactType = "";
          var contactTypeElement = $('input:radio[name=RadioGroup1]:checked');
          if (contactTypeElement) {
             contactType = contactTypeElement.val();
          }

          var email = $("#email").val();
          var phone = $("#phone").val();
          var comments = $("#comments").val();

          if(firstName != null && firstName != "") {
             trackData = "First Name";
             hasTrackData = "Y";
          }
          if(lastName != null && lastName != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Last Name";
             hasTrackData = "Y";
          }
          if(contactType != null && contactType != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Contact Type";
             hasTrackData = "Y";
          }
          if(email != null && email != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Email";
             hasTrackData = "Y";
          }
          if(phone != null && phone != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Phone";
             hasTrackData = "Y";
          }
          if(comments != null && comments != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Comments";
             hasTrackData = "Y";
          }

          //Receive C21 Emails
          if(hasTrackData) trackData = trackData + ",";
          trackData = trackData + "Receive C21 Emails";
          hasTrackData = "Y";

          if(hasTrackData && sourcePage != null && sourcePage != "") {
             Track.doEvent(sourcePage, 'Form Abandonment', trackData);
          }
      },

      /**
       * GA Tracking of Inline Lead Contact Form - PDP
       *
       */
      gaTrackLeadPDPInlineContactForm : function(sourcePage, contactTypeChanged, commentsChanged) {
          var trackData = "";
          var hasTrackData = "";
          var firstName = $("#firstName").val();
          var lastName = $("#lastName").val();
          var yesiwould = $("#c21emails");

          var contactType = "";
          var contactTypeElement = $('input:radio[name=RadioGroup1]:checked');
          if (contactTypeElement) {
             contactType = contactTypeElement.val();
          }

          var email = $("#email").val();
          var phone = $("#phone").val();
          var comments = $("#comments").val();

          if(firstName != null && firstName != "") {
             trackData = "First Name";
             hasTrackData = "Y";
          }
          if(lastName != null && lastName != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Last Name";
             hasTrackData = "Y";
          }
          if(contactTypeChanged && contactType != null && contactType != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Contact Type";
             hasTrackData = "Y";
          }
          if(email != null && email != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Email";
             hasTrackData = "Y";
          }
          if(phone != null && phone != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Phone";
             hasTrackData = "Y";
          }
          if(commentsChanged && comments != null && comments != "") {
             if(hasTrackData) trackData = trackData + ",";
             trackData = trackData + "Comments";
             hasTrackData = "Y";
          }

          // Receive C21 Emails
          if(yesiwould.is(':visible') && !yesiwould.attr("checked")) {
	         if(hasTrackData) trackData = trackData + ",";
	         trackData = trackData + "Receive C21 Emails";
	         hasTrackData = "Y";
          }

          if(hasTrackData && sourcePage != null && sourcePage != "") {
             Track.doEvent(sourcePage, 'Form Abandonment', trackData);
          }
      },

      /**
       * GA Tag: Contact Us Form Abandonment
       *
       */
      gaTrackFormAbandonmentContactUs : function(formType, contactTypeChanged, isVeteranChanged) {
    	  if(formType == null || formType == "") {
    		  return;
    	  }

          var trackData = "";
          var hasTrackData = "";
          var firstname = $("#firstname").val();
          var lastname = $("#lastname").val();
          var email = $("#email").val();
          var phone = $("#phone").val();
          var subject = $("#subject").val();
          var comments = $("#comments").val();
          var yesiwould = $("#yesiwould");

          //form fields
          if(formType == "General") {
        	  //Full Name
              var name = $("#name").val();
	          if(name != null && name != "") {
	              trackData = "Full Name";
	              hasTrackData = "Y";
	          }
          }
          if(formType == "List a Property") {
        	  //Zipcode
              var zipcode = $("#zipcode").val();
	          if(zipcode != null && zipcode != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Zip Code";
	              hasTrackData = "Y";
	          }
        	  //Office Keys
              var officekeys = "";
              var sep = "";
              var cb_officekeys = $('input:checkbox[name=officekey]:checked');
              for(var i=0; i<cb_officekeys.length; i++){
                 officekeys += sep+cb_officekeys[i].value;
                 sep=",";
              }
        	  if(officekeys != null && officekeys != "") {
                  if(hasTrackData) trackData = trackData + ",";
                  trackData = trackData + "Office Keys";
                  hasTrackData = "Y";
        	  }
          }
          if(formType == "Media" || formType == "Career" || formType == "Franchise" || formType == "List a Property") {
        	  //First Name
              var firstname = $("#firstname").val();
	          if(firstname != null && firstname != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "First Name";
	              hasTrackData = "Y";
	          }
	          //Last Name
              var lastname = $("#lastname").val();
	          if(lastname != null && lastname != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Last Name";
	              hasTrackData = "Y";
	          }
          }
          if(formType == "Media") {
        	  //Title
        	  var title = $("#title").val();
        	  if(title != null && title != "") {
                  if(hasTrackData) trackData = trackData + ",";
                  trackData = trackData + "Title";
                  hasTrackData = "Y";
        	  }
        	  //Affiliation
        	  var affiliation = $("#affiliation").val();
        	  if(affiliation != null && affiliation != "") {
                  if(hasTrackData) trackData = trackData + ",";
                  trackData = trackData + "Affiliation";
                  hasTrackData = "Y";
        	  }
          }
          if(formType == "Media" || formType == "Career" || formType == "Franchise") {
        	  //Contact Type
	          var contactType = $('input:radio[name=contacttype]:checked').val();
	          if(contactTypeChanged && contactType != null && contactType != "") {
	              if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Contact Type";
	              hasTrackData = "Y";
	          }
          }
          //Email
          if(email != null && email != "") {
              if(hasTrackData) trackData = trackData + ",";
              trackData = trackData + "Email";
              hasTrackData = "Y";
          }
          //Phone
          if(phone != null && phone != "") {
              if(hasTrackData) trackData = trackData + ",";
              trackData = trackData + "Phone";
              hasTrackData = "Y";
          }
          if(formType == "Career") {
        	  //Address
              var address = $("#address").val();
	          if(address != null && address != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Address";
	              hasTrackData = "Y";
	          }
          }
          if(formType == "Career" || formType == "Franchise") {
        	  //City
              var city = $("#city").val();
	          if(city != null && city != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "City";
	              hasTrackData = "Y";
	          }
	          //State
              var state = $("#state").val();
	          if(state != null && state != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "State";
	              hasTrackData = "Y";
	          }
          }
          if(formType == "Career") {
        	  //Zip code
              var zipcode = $("#zipcode").val();
	          if(zipcode != null && zipcode != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Zip Code";
	              hasTrackData = "Y";
	          }
          }
          if(formType == "Career") {
        	  //Have license
	          var havelicense = $('input:radio[name=havelicense]:checked').val();
	          if(havelicense != null && havelicense != "") {
	              if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Have a Real Estate License";
	              hasTrackData = "Y";
	          }
          }
          if(formType == "Franchise") {
        	  //Company name
              var companyname = $("#companyname").val();
	          if(companyname != null && companyname != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Company Name";
	              hasTrackData = "Y";
	          }
	          //Time in business
              var timeinbusiness = $("#timeinbusiness").val();
	          if(timeinbusiness != null && timeinbusiness != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Time in Business";
	              hasTrackData = "Y";
	          }
	          //Current Job Title
              var currentjob = $("#currentjob").val();
	          if(currentjob != null && currentjob != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Current Job Title";
	              hasTrackData = "Y";
	          }
	          //Part of Franchise
	          var partoffranchise = $('input:radio[name=partoffranchise]:checked').val();
	          if(partoffranchise != null && partoffranchise != "") {
	              if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Part of Franchise";
	              hasTrackData = "Y";
	          }
	          //Brand
              var brand = $("#brand").val();
	          if(brand != null && brand != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Brand";
	              hasTrackData = "Y";
	          }
	          //Solution time
              var franchisetime = $("#franchisetime").val();
	          if(franchisetime != null && franchisetime != "") {
	        	  if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Solution time";
	              hasTrackData = "Y";
	          }
	          //Veteran
	          var veteran = $('input:radio[name=veteran]:checked').val();
	          if(isVeteranChanged && veteran != null && veteran != "") {
	              if(hasTrackData) trackData = trackData + ",";
	              trackData = trackData + "Veteran";
	              hasTrackData = "Y";
	          }
          }
          if(formType == "General") {
        	  //Category
        	  var category = $("#category").val();
        	  if(category != null && category != "") {
                  if(hasTrackData) trackData = trackData + ",";
                  trackData = trackData + "Category";
                  hasTrackData = "Y";
        	  }
        	  //Subject
              if(subject != null && subject != "") {
                  if(hasTrackData) trackData = trackData + ",";
                  trackData = trackData + "Subject";
                  hasTrackData = "Y";
              }
          }
          //Comments
          if(comments != null && comments != "") {
              if(hasTrackData) trackData = trackData + ",";
              trackData = trackData + "Comments";
              hasTrackData = "Y";
          }
          //Receive e-mail from Century 21
          if(yesiwould != null && !yesiwould.attr("checked")) {
              if(hasTrackData) trackData = trackData + ",";
              trackData = trackData + "Receive e-mail from Century 21";
              hasTrackData = "Y";
          }

          if(hasTrackData && formType != null && formType != "") {
             Track.doEvent("Contact Us - " + formType, 'Form Abandonment', trackData);
          }
      }

   };
}());
